import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, Eye, EyeOff, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La password deve essere di almeno 6 caratteri"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, new_password: password });
      setDone(true);
      toast.success("Password aggiornata!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nel reset della password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex flex-col items-center justify-center px-4">
      <div className="flex flex-col items-center gap-3 mb-8">
        <img src="/icon-192.png" alt="venditoreElite" className="w-16 h-16 rounded-2xl shadow-xl" />
        <h1 className="text-white font-bold text-2xl">venditoreElite</h1>
        <p className="text-white/40 text-sm">Reset password</p>
      </div>

      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-6">
        {done ? (
          <div className="text-center space-y-4 py-4">
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
            <p className="font-semibold text-[#0F172A]">Password aggiornata!</p>
            <p className="text-sm text-slate-500">Ora puoi accedere con la nuova password.</p>
            <Button onClick={() => navigate("/auth")} className="w-full bg-[#0F172A] text-white mt-2">
              Vai al login
            </Button>
          </div>
        ) : (
          <>
            {!token && (
              <p className="text-sm text-red-500 mb-4">Link non valido o mancante.</p>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="new-pwd">Nuova password</Label>
                <div className="relative mt-1">
                  <Input
                    id="new-pwd"
                    data-testid="reset-password-input"
                    type={showPwd ? "text" : "password"}
                    placeholder="Almeno 6 caratteri"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="pr-10"
                    required
                    disabled={!token}
                  />
                  <button type="button" onClick={() => setShowPwd(v => !v)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                    {showPwd ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <Button type="submit" disabled={loading || !token} className="w-full bg-[#0F172A] text-white"
                data-testid="reset-password-submit">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Aggiorna password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
